export default __webpack_public_path__ + "static/media/pic1.69f38e53.jpg";